import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-form-group',
  template: `
    <div class="form-group">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class FormGroupWrapperComponent extends FieldWrapper {}
